<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Monthly New Joinee Report</h5>
  </div>
  <div id="mainContent" class="container">
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Financial Year<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedFinancialYear"
                (change)="onFinancialYearSelected()">
                <option value="">Select Year</option>
                <option *ngFor="let finance of financialList" [ngValue]="finance">
                  {{ finance.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Branch<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedBranch" #designateBranch="ngModel">
                  <mat-option (click)="selectAllBranch(designateBranch, branchList)" [value]="0">Select All
                  </mat-option>
                  <mat-option #item *ngFor="let branch of branchList" [value]="branch">
                    {{ branch.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- From Month Dropdown -->
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">
              From Month<span class="text-danger">*</span>
            </label>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="fromMonthId">
                <option value="">Select From Month</option>
                <option *ngFor="let month of getFilteredFromMonths()" [ngValue]="month.id">
                  {{ month.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- To Month Dropdown -->
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">
              To Month<span class="text-danger">*</span>
            </label>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="toMonthId" (change)="onToMonthChange()">
                <option value="">Select To Month</option>
                <option *ngFor="let month of getFilteredToMonths()" [ngValue]="month.id">
                  {{ month.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-sm-2">
          <button type="button" class="btn btn-sm btn-block btn-outline-theme"
            (click)="getMonthlyNewJoineeReportdetails()">
            View Report
          </button>
        </div>
        <div class="col-sm-2" *ngIf="showExportToExcelButton">
          <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onExportToExcelReport()">
            Export To Excel
          </button>
        </div>
        <div class="col-sm-2" *ngIf="showExportToExcelButton">
          <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
            <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container pt-3" id="mainContent" *ngIf="monthlyNewJoineeReport.length>0">
  <div class="row justify-content-center text-center">
    <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>
  <div class="row mt-2 justify-content-center text-center">
    <span class="bg-theme-title">Monthly New Joinee Report</span>
  </div>
  <div class="row col-md-12 mt-3" *ngFor="let item of monthlyNewJoineeReport;let i=index;">
    <div><label class="col-form-label"><b>Branch : </b>
        {{item.branch}}</label>
    </div>
    <!-- <div class="row col-md-12 "><label class="col-form-label"><b>Month : </b>
    {{item.month}}</label>
  </div>
  <div class="row col-md-12 "><label class="col-form-label"><b>Year : </b>
    {{item.fy}}</label>
  </div> -->
    <table class="table table-bordered table-sm">
      <thead>
        <tr>
          <th>Id</th>
          <th>Name</th>
          <th>Birth Date</th>
          <!-- <th>Month</th> -->
          <th>Joining Date</th>
          <th>Designation</th>
          <th>Monthly CTC Status</th>
          <th>Location</th>
        </tr>
      </thead>
      <tbody *ngFor="let data of item.joineeDto;let i=index;">
        <td>{{i+1}}</td>
        <td>{{data.name}}</td>
        <td>{{data.birthDate |date: "dd-MM-yyyy"}}</td>
        <!-- <td>{{data.monthName}}</td> -->
        <td>{{data.joiningDate |date: "dd-MM-yyyy"}}</td>
        <td>{{data.designation}}</td>
        <td>{{data.ctcStatus==''?data.stipendStatus:data.ctcStatus}}</td>
        <td>{{data.location}}</td>
      </tbody>

    </table>
  </div>
</div>